import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { useAnimatedScrollHandler } from 'react-native-reanimated';
import { CardView } from 'design-system/CardView';
import { AppView, SCROLL_INDICATOR_INSETS, rem } from 'design-system';
import StatusBar from 'design-system/StatusBar';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import LearnArticleCard from './LearnArticleCard';
import { isWeb } from '../../../../constants';
// const keyExtractor = extractKeyFromKey('name');
const EMPTY_ARTICLES = [];
const LearnArticles = withAnimatedNavigationHeader(({ scrollY, route }) => {
    const learnArticles = route.params.learnArticles || EMPTY_ARTICLES;
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const renderItem = useCallback(({ item, index }) => <LearnArticleCard forList data={item} key={index}/>, []);
    const containerStyles = useMarginBottom('paddingBottom', 0, styles.scrollView, paddingHorizontalStyle);
    const scrollHandler = useAnimatedScrollHandler((handle) => {
        // eslint-disable-next-line no-param-reassign
        scrollY.value = handle.contentOffset.y;
    });
    if (!learnArticles?.length) {
        return null;
    }
    return (<AppView type="secondary" withFrame={false}>
        {isWeb ? (<>
            <StatusBar barStyle="dark-content" animated/>
            <View style={paddingHorizontalStyle}>
              <CardView webPadding noMarginBottom>
                <Animated.FlatList data={learnArticles} renderItem={renderItem} scrollEventThrottle={16} onScroll={scrollHandler} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}/>
              </CardView>
            </View>
          </>) : (<>
            <StatusBar barStyle="dark-content" animated/>
            <Animated.FlatList data={learnArticles} renderItem={renderItem} scrollEventThrottle={16} onScroll={scrollHandler} contentContainerStyle={[containerStyles]} showsVerticalScrollIndicator scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}/>
          </>)}
      </AppView>);
}, ({ colors }) => ({
    title: 'Articles',
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    scrollView: {
        paddingTop: rem(8),
    },
});
export default LearnArticles;
